import { AfterViewInit, ChangeDetectorRef, Component, Inject, LOCALE_ID, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FilterService, MenuItem, MessageService, SelectItem } from 'primeng/api';
import { ExportOfferGateway } from 'src/app/application/gateway/ExportOfferGateway';
import { PortGateway } from 'src/app/application/gateway/PortGateway';
import { CountryService } from 'src/app/application/service/CountryService';
import { Country } from 'src/app/domain/models/Country';
import { MarketplaceResult, ExportOfferAd } from 'src/app/domain/models/ExportOffer';
import { Variety } from 'src/app/domain/models/Variety';
import { Species } from 'src/app/domain/models/Species';
import { ImportRequest, ImportRequestAds, ImportRequestInformation } from 'src/app/domain/models/ImportRequest';
import { TranslateService } from '@ngx-translate/core';
import { Routes } from 'src/app/infrastructure/routes';
import { BasicUser } from 'src/app/domain/models/User';
import { AuthGateway } from 'src/app/application/gateway/AuthGateway';
import { ImportRequestService } from 'src/app/application/service/ImportRequestService';
import { ImportRequestUtil } from '../../util/import-request-util';
import { SpeciesUtils } from '../../util/species-utils';
import * as moment from 'moment';

@Component({
  selector: 'app-external-marketplace-page',
  templateUrl: './external-marketplace-page.component.html',
  styleUrls: ['./external-marketplace-page.component.css'],

})
export class ExternalMarketplacePageComponent implements OnInit {
  formGroup: FormGroup = this._formBuilder.group({
    countryFromId: ['', Validators.required],
    filter: ['']
  })

  importRequestForm: FormGroup = this._formBuilder.group({
    countryFromId: ['', Validators.required],
  })

  loading: boolean = false

  selectedImportRequest: ImportRequestInformation | undefined
  selectedCountryFrom: Country | undefined
  selectedCountryTo: Country | undefined

  adsCode: string | undefined

  marketplaceResult: MarketplaceResult | undefined

  offers: ExportOfferAd[] = []
  filteredOffers: ExportOfferAd[] = []
  importRequests: ImportRequestAds[] = []
  filteredImportRequest: ImportRequestAds[] = []
  originCountries: Country[] = []
  originCountriesImportRequest: Country[] = []
  originCountriesOptions: any[] = []

  speciesArray: string[] = []
  varietiesArray: string[] = []
  speciesFilter: SelectItem[] = []
  varietiesFilter: SelectItem[] = []

  speciesImporterArray: string[] = []
  varietiesImporterArray: string[] = []
  speciesImporterFilter: SelectItem[] = []
  varietiesImporterFilter: SelectItem[] = []

  visibleOfferDetailDialog: boolean = false
  pallets: number = 0

  filterForm: FormGroup;
  filterImportRequestForm: FormGroup = this._formBuilder.group({
    filterMobile: ['', Validators.required]
  });

  itemsFiltered = [...this.filteredOffers];
  itemsFilteredImportRequest = [...this.filteredImportRequest]

  breadcrumbItems: MenuItem[] = []
  breadcrumbItemsEN: MenuItem[] = []

  tabIndex = 0;
  activeTab = 0;

  selectedImportRequestCountryFrom: Country | undefined

  constructor(@Inject(LOCALE_ID) public locale: string,
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _formBuilder: FormBuilder,
    private _messageService: MessageService,
    private _exportOfferService: ExportOfferGateway,
    private _portService: PortGateway,
    private _countryService: CountryService,
    public translate: TranslateService,
    private cdr: ChangeDetectorRef,
    public _importRequestService: ImportRequestService,
    private readonly filterService: FilterService
    ) {
      this.loadExportOffers(),
      this.loadImportRequests()
      this.filterForm = new FormGroup({
        filterMobile: new FormControl(this.offers)  // Aquí puedes establecer un valor inicial
      });
      // Detectar cambios en el FormControl
      this.filterForm.get('filterMobile')?.valueChanges.subscribe(value => {
        this.functionFilter(value)
      });

      this.filterImportRequestForm.get('filterMobile')?.valueChanges.subscribe(value => {
        this.functionFilterImportRequest(value)
      });
  }


  functionFilter(filtro: string): void {
    const searchText = filtro.toLowerCase();
    this.itemsFiltered = this.offers.filter(offer => {
      return offer.variety.species.name.toLowerCase().includes(searchText) ||
        offer.variety.name.toLowerCase().includes(searchText) ||
        offer.speciesSize.toLowerCase().includes(searchText);
    });
  }

  functionFilterImportRequest(filtro: string): void {
    const searchText = filtro.toLowerCase();
    this.itemsFilteredImportRequest = this.importRequests.filter(request => {
      return request.variety.species.name.toLowerCase().includes(searchText) ||
      request.variety.name.toLowerCase().includes(searchText) ||
      request.speciesSize?.toLowerCase().includes(searchText);
    });
  }

  ngOnInit(): void {

    this.loadCountries()
    this.loadCountriesImportRequest()
    this.loadExportOffers()

    this._activatedRoute.queryParams.subscribe(params => {
      const tab = params['tab']; // Obtener parámetro de la URL
      if (tab !== undefined) {
         this.tabIndex = parseInt(tab);
      }
    });

    this.filterService.register('filter-date', (value: any, filter: any): boolean => {
      if (!filter) return true
      const found = moment(value).format("DD-MM-YYYY") === moment(filter).format("DD-MM-YYYY")
      return found;
    });
  }

  ngAfterViewInit(): void {

    this.breadcrumbItems = [
      { label: 'Inicio',  routerLink: ['/' + Routes.homePage]},
      { label: 'Ver mas ofertas', disabled: true}
    ]
    this.breadcrumbItemsEN = [
      { label: 'Home',  routerLink: ['/' + Routes.homePage]},
      { label: 'See more offers', disabled: true}
    ]

  }

  get lang(): string {
    return this.translate.currentLang
  }

  ngAfterViewChecked(): void {
    this.itemsFiltered=this.offers
    //if(this.filterForm.get('filterMobile') && this.filterForm.get('filterMobile')!.value !== '') {
    //  this.itemsFiltered=this.offers
    //}
    //this.cdr.detectChanges();
  }

  loadExportOffers() {
    this.loading = true
    this._exportOfferService.getAllForMarketPlaceAds().subscribe({
      next: (v) => {
        this.offers = v
        this.filteredOffers = this.offers

        v.forEach(x => {
          x.specieName = this.getSpeciesName(x.variety.species)
          this.setFilters(x)
        })

        this.sortFiters()
        this.loading = false
      },
      error: (e) => {
        this.loading = false
        this._messageService.add({ severity: 'error',
        summary: this.translate.instant('MessageService.Summary.FailedAction'),
        detail: this.translate.instant('MessageService.ExportOffer.ManyRetrieveError') })
      }
    })
  }

  setFilters(row: ExportOfferAd) {
    if (row.specieName && !this.speciesArray.includes(row.specieName)) {
      this.speciesArray.push(row.specieName)
      this.speciesFilter.push({value: row.specieName, label: row.specieName})
    }
    if (row.variety.name && !this.varietiesArray.includes(row.variety.name)) {
      this.varietiesArray.push(row.variety.name)
      this.varietiesFilter.push({value: row.variety.name, label: row.variety.name})
    }
  }

  sortFiters() {
    this.speciesFilter.sort()
    this.varietiesFilter.sort()
  }

  getSpeciesName(data: any): string {
    if (this.lang) {
      return SpeciesUtils.getSpeciesName(this.lang, data)
    }
    return ''
  }

  onSelectCountryFrom(){
    this.selectedCountryFrom = this.originCountries.find(
      x => x.id == this.importRequestForm.controls['countryFromId'].value
    )
  }
  loadImportRequests(){
    this.loading = true
    this._importRequestService.getImportRequestForMarketplaceAds().subscribe({
      next: (v) => {
        this.importRequests = v
        this.filteredImportRequest = this.importRequests

        v.forEach(x => {
          x.specieName = this.getSpeciesName(x.variety.species)
          this.setImporterFilters(x)
        })

        this.sortImporterFiters()
        this.loading = false
      },
      error: (e) => {
        this.loading = false
        this._messageService.add({ severity: 'error',
        summary: this.translate.instant('MessageService.Summary.FailedAction'),
        detail: this.translate.instant('MessageService.ImportRequest.ManyRetrieveError') })
      }
    })

  }

  setImporterFilters(row: ImportRequestAds) {
    if (row.specieName && !this.speciesImporterArray.includes(row.specieName)) {
      this.speciesImporterArray.push(row.specieName)
      this.speciesImporterFilter.push({value: row.specieName, label: row.specieName})
    }
    if (row.variety.name && !this.varietiesImporterArray.includes(row.variety.name)) {
      this.varietiesImporterArray.push(row.variety.name)
      this.varietiesImporterFilter.push({value: row.variety.name, label: row.variety.name})
    }
  }

  sortImporterFiters() {
    this.speciesImporterFilter.sort()
    this.varietiesImporterFilter.sort()
  }

  loadCountries() {
    this._exportOfferService.getCountriesAvailable().subscribe({
      next: (v) => {
        this.originCountries = v
        this.selectedCountryFrom = this.originCountries.find(x => x.id ===
          this.formGroup.controls['countryFromId'].value)
      },
      error: (e) => {
        this.loading = false
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.Country.DestinationManyRetrieveError') })
      }
    })
  }

  loadCountriesImportRequest() {
    this._importRequestService.getCountriesAvailable().subscribe({
      next: (v) => {
        this.originCountriesImportRequest = v
        this.selectedImportRequestCountryFrom = this.originCountriesImportRequest.find(x => x.id ===
          this.formGroup.controls['countryFromId'].value)
      },
      error: (e) => {
        this.loading = false
        this._messageService.add({ severity: 'error',
          summary: this.translate.instant('MessageService.Summary.FailedAction'),
          detail: this.translate.instant('MessageService.Country.DestinationManyRetrieveError') })
      }
    })
  }



  @ViewChild('dt1') dataTable: any
  filterGlobal(value: string)
  {
    this.dataTable.filterGlobal(value, 'contains')
  }

  filterGlobalEvent(event: any)
  {
    this.filterGlobal(event.target.value)
  }

  @ViewChild('dt2') dataTableImportRequest: any
  filterGlobalImportRequest(value: string)
  {
    this.dataTableImportRequest.filterGlobal(value, 'contains')
  }

  filterGlobalImportRequestEvent(event: any) {
    this.filterGlobalImportRequest(event.target.value);
  }

  clearSpotSearchParams()
  {
    this.formGroup.controls['countryFromId'].setValue(null)
    this.filteredOffers = this.offers
  }

  clearSpotSearchParamsImportRequest()
  {
    this.importRequestForm.controls['countryFromId'].setValue(null)
    this.filteredImportRequest = this.importRequests
  }

  navigateToDetail(adsCode: string) {
      this._router.navigate(['/'+ Routes.offerDetail, adsCode])
  }

  navigateToDetailImport(adsCode: string) {
    this._router.navigate(['/'+ Routes.externalImportRequestDetail, adsCode])
  }

  navigateToImportRequestDetail(adsCode: string)
  {
    this._router.navigate(['/'+ Routes.externalImportRequestDetail, adsCode])
  }

  onChangeCountryFrom()
  {
    this.selectedCountryFrom = this.originCountries.find(
      x => x.id == this.formGroup.controls['countryFromId'].value
    )
  }

  onChangeCountryFromImportRequest()
  {
    this.selectedImportRequestCountryFrom = this.originCountriesImportRequest.find(
      x => x.id == this.importRequestForm.controls['countryFromId'].value
    )
  }

  applyFilterMarketplace()
  {
    if(this.selectedCountryFrom)
    {
      let countryId = this.selectedCountryFrom.id
      this.filteredOffers = this.offers.filter(x => x.country.id === countryId)
    }

    this.filterGlobal(this.formGroup.controls['filter'].value);
  }



  applyFilterImportRequest()
  {
    if(this.selectedImportRequestCountryFrom)
    {
      let countryId = this.selectedImportRequestCountryFrom.id
      this.filteredImportRequest = this.importRequests.filter(x => x.countryFrom?.id === countryId)
    }

    this.filterGlobalImportRequest(this.formGroup.controls['filter'].value);
  }

  getTotalContainersImportRequest(importRequest: ImportRequest): number {
    return ImportRequestUtil.getTotalContainers(importRequest)
  }

  getTotalWeeksImportRequest(importRequest: ImportRequest): number {
    return ImportRequestUtil.getTotalWeeks(importRequest)
  }

  getTotalPalletsImportRequest(importRequest: ImportRequest): number {
    return ImportRequestUtil.getTotalPallets(importRequest)
  }
}
